import React, { useEffect, useRef } from "react"
import DataTable from "react-data-table-component"
import loadingGif from "../../../../../../Assets/Images/Animations/loading-management-console.gif";
import "./styles.scss";

const LazyTable = ({
  d,
  table,
  customStyles,
  loading,
  pageNo,
  totalRows,
  handlePerRowsChange,
  customerNameDefaultValue,
  handlePageChange,
  styles,
  handleLazyCalls,
  serverErrorUser,
  emptyUser,
  emptyUserFilters,
  emptyUserSearch,
  emptyCloudSummaryReseller,
  setScrollToDivTop,
  scrollToDivTop,
}) => {
  const tableRef = useRef(null);

  useEffect(() => {
    if (table && totalRows) {
      const _table = tableRef.current;
      const divInside = _table && _table.querySelector('div');
      let hasCalledLazyCalls = false;

      const handleScroll = () => {
        // console.log(divInside.scrollTop + divInside.clientHeight);
        // console.log(divInside.scrollHeight);
        const buffer = 1;
        if ((divInside.scrollTop + divInside.clientHeight + buffer) > divInside.scrollHeight) {
          // console.log("BOTTOM");
          // console.log("totalRows", totalRows);
          // console.log("tableLength", table.length);
          if (!hasCalledLazyCalls && totalRows > table.length) {
            hasCalledLazyCalls = true;
            handleLazyCalls();
          }
        }
      };

      divInside && divInside.addEventListener('scroll', handleScroll);


      return () => {
        divInside && divInside.removeEventListener('scroll', handleScroll);
      };
    }
  }, [table, totalRows]);

  useEffect(() => {
    const _table = tableRef.current;
    const divInside = _table && _table.querySelector('div');

    if (scrollToDivTop == true) {
      divInside.scrollTop = 0;
      setScrollToDivTop(false);
    }
  }, [scrollToDivTop])


  // useEffect(() => {
  //   if (tableRef && tableRef.current) {
  //     const immediateChildDiv = tableRef.current.querySelector('div');
  //     console.log("immediateChildDiv", immediateChildDiv)
  //     if (immediateChildDiv) {
  //       if (loading) {
  //         immediateChildDiv.style.overflowY = "hidden";
  //       } else {
  //         immediateChildDiv.style.overflowY = "auto";
  //       }
  //     }
  //   }
  // }, [loading])

  return (
    <div className="responsive-table" ref={tableRef}>
      {!serverErrorUser && !emptyUser && !emptyUserFilters && !emptyUserSearch && !emptyCloudSummaryReseller &&
        <DataTable
          columns={d}
          data={table}
          theme="solarized"
          customStyles={customStyles}
          noDataComponent={<div className={styles["no-data-cloud-summary"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading Summaries ...</p></div>}
          width="100%"
          fixedHeaderScrollHeight="60vh"
          fixedHeader
          persistTableHead={false}
          onChangePage={(pageNo) => handlePageChange(pageNo, totalRows)}
          onChangeRowsPerPage={handlePerRowsChange}
        />}
      <div className="infinity-loader-wrapper">
        {loading && <div className="text-center"><img className="management-console-loading-icon" src={loadingGif} /></div>}
      </div>
    </div>

  )
};

export default LazyTable;